import { createSelector } from '@reduxjs/toolkit';

import { getAllRelativeGeometries, getRelativeGeometryName } from '@paragon/relative-geometry';
import { keyMapBy } from '@paragon/utilities';

import { getActiveComponentDesign } from './getActiveComponentDesignSelector';
import { getReferenceLinesForActiveComponent } from './getReferenceLinesForActiveComponent';

export const getReferenceLineShortNamesByGuidForActiveComponent = createSelector(
  getActiveComponentDesign,
  getReferenceLinesForActiveComponent,
  (componentDesign, referenceLines): ReadonlyMap<string, string> | null => {
    if (componentDesign == null || referenceLines == null) return null;

    const relativeGeometriesByGuid = keyMapBy(
      getAllRelativeGeometries(componentDesign.component),
      (relativeGeometry) => relativeGeometry.guid,
    );

    return new Map(
      referenceLines.map((referenceLine) => {
        let name: string;
        if (referenceLine.lineType === 'Member') {
          const relativeGeometry = relativeGeometriesByGuid.get(referenceLine.memberGeometryGuid);
          if (relativeGeometry == null) throw new Error('Relative geometry for member line could not be found.');
          name = getRelativeGeometryName(relativeGeometry);
        } else name = referenceLine.name;

        return [referenceLine.guid, name];
      }),
    );
  },
);
